<template>
  <div class="inner-layout">

    <div class="page-title">1:1문의</div>

    <div class="board-container board-inquiry">

      <validateForm ref="form">
        <div class="inquiry-subject">제목<span class="color-1">* </span></div>
        <input-field v-model="title" :validate="rules.title" placeholder="제목을 입력해주세요." maxLength="50"/>

        <div class="inquiry-subject">문의사항<span class="color-1">* </span></div>
        <input-field multiline rows="10" v-model="content" :validate="rules.content" placeholder="문의사항을 입력해주세요."/>
      </validateForm>

      <div class="mt-50 ta-center">
        <router-link to="/inquiry" class="mr-5 btn w-100 btn-outline color-6">취소</router-link>
        <button @click="save" class="btn w-100 color-1">{{ idx ? '수정' : '등록' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex"
export default {
  name: "inquirySave",
  data() {
    return {
      idx: this.$route.name === 'inquiry/new' ? 0 : this.$route.params.idx,
      title: '',
      content: '',
      rules: {
        title: [v => !!v || this.$msg('required.input')],
        content: [v => !!v || this.$msg('required.input')],
      },
    }
  },
  mounted() {
    if (this.idx) this.setItem();
  },
  methods:{
    ...mapActions({
      setMsgPopup: 'common/setMsgPopup',
    }),
    async setItem() {
      const { result, data } = await this.$api.getInquiryDetail({ idx: this.idx })
      if (result === 'success') {
        this.title = data.title
        this.content = data.content
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        const { result } = await this.$api.saveInquiry({
          idx: this.idx,
          title: this.title,
          content: this.content
        });
        if (result === 'success') this.alertPopup()
      }
    },
    alertPopup() {
      this.setMsgPopup({
        type: 'alert',
        message: this.idx === 0 ? this.$msg('ok.insert') : this.$msg('ok.update'),
        okay: 'OK',
        okayCallback: () => {
          this.setMsgPopup()
          this.$router.go(-1)
        }
      })
    },
  }
}
</script>
